<style scoped lang="scss">
@import "../user";
@media screen and (max-width: 640px) and (min-width: 600px){
  .order ul li{
    width: calc((100% - 14px * 3) / 3) !important;
    margin-bottom: 15px;
  }
  .order ul li:nth-child(3n){
    margin-right: 0;
  }
  .order ul li:nth-last-of-type(1),.order ul li:nth-last-of-type(2),.order ul li:nth-last-of-type(3){
    margin-bottom: 0;
  }
  .user .title10{
    width: 75%;
    font-size: 20px;
  }
  .user .you{
    margin-top: 5px;
  }
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (min-width: 300px) and (max-width:400px){
  .order ul li{
    width: calc((100% - 7px * 3) / 2) !important;
    margin-bottom: 15px;
  }
  .order ul li:nth-last-of-type(1),.order ul li:nth-last-of-type(2){
    margin-bottom: 0;
  }
  .order ul li:nth-child(2n){
    margin-right: 0;
  }
  .user .title10{
    width: 65%;
    font-size: 20px;
  }
  .user .you{
    margin-top: 5px;
  }
}
@media screen and (max-width: 414px) and (min-width: 413px){
  .order ul li{
    width: calc((100% - 7px * 3) / 2) !important;
    margin-bottom: 15px;
  }
  .order ul li:nth-last-of-type(1),.order ul li:nth-last-of-type(2){
    margin-bottom: 0;
  }
  .order ul li:nth-child(2n){
    margin-right: 0;
  }
  .user .title10{
    width: 65%;
    font-size: 20px;
  }
  .user .you{
    margin-top: 5px;
  }
}
.order ul {
    display: flex;
    flex-wrap: wrap;
  }

.order ul li {
    position: relative;
    width: calc((100% - 20px * 3) / 4);
    margin-top: 20px;
    margin-right: 20px;
    transition: box-shadow 0.3s;
  }

.order ul li:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

.order ul li:nth-child(-n+4) {
    margin-top: 0;
  }

.order ul li:nth-child(4n) {
    margin-left: -1px;
    margin-right: 0;
  }

.order ul li .name {
    position: relative;
    padding-top: 35px;
    padding-bottom: 10px;
    color: #ffffff;
    text-align: center;
    overflow: hidden;
    background-color: #3bc9db;
    background: -webkit-linear-gradient(55deg, #3bc9db, #66d9e8);
    background: -moz-linear-gradient(55deg, #3bc9db, #66d9e8);
    background: linear-gradient(55deg, #3bc9db, #66d9e8);
  }

.order ul li.disabled .name {
    background-color: #9c9c9c;
  }

.order ul li .name .used,
.order ul li .name .expired,
.order ul li .name .not-used {
    position: absolute;
    top: -14px;
    left: -36px;
    display: inline-block;
    padding: 30px 30px 3px 30px;
    color: #333333;
    background-color: #aaaaaa;
    transform: rotate(-45deg);
  }

.order ul li .name .not-used {
    background-color: #ffdf5e;
  }

.order ul li .name:after {
    position: absolute;
    top: -5px;
    left: 50%;
    content: "";
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ffffff;
    transform: translate(-50%, -50%);
  }

.order ul li .name h5 {
    margin-bottom: 30px;
    padding: 0 30px;
    font-size: 20px;
  }

.order ul li .name p {
    color: #008085;
  }

.order ul li.disabled .name p {
    color: #333333;
  }

.order ul li .store {
    position: relative;
    padding: 20px 15px;
    color: #666666;
    text-align: center;
    background-color: #f8f8f8;
  }

.order ul li .store:after {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    content: "";
    height: 3px;
    background: url("../../../assets/img/coupon.png") repeat-x;
  }

.order ul li.disabled .store:after {
    background: url("../../../assets/img/coupon-disabled.png") repeat-x;
  }

.order ul li .store .text-left {
    display: block;
    text-align: left;
    color:#666666!important;
    margin-bottom: 10px;
  }
.order ul li .store p {
  display: block;
  margin-bottom: 10px;
}

.order ul li .store span {
    color: #333333;
  }

.order ul li .store .btn {
    display: inline-block;
    width: 120px;
    border: 1px solid #4fc8cc;
    margin-bottom: 0;
    padding: 7px 0;
    color: #4fc8cc;
    border-radius: 20px;
    outline: none;
    background-color: transparent;
    transition: color 0.3s, border-color 0.3s;
  }
.order ul li .store .btn1 {
  display: inline-block;
  width: 120px;
  border: 1px solid #9c9c9c;
  margin-bottom: 0;
  padding: 7px 0;
  color: #666666;
  border-radius: 20px;
  outline: none;
  background-color: transparent;
  transition: color 0.3s, border-color 0.3s;
}

.order ul li.disabled .store .btn {
    color: #666666;
    border-color: #9c9c9c;
  }
.order ul li.disabled .store .btn:hover {
  color: #666666;
  border-color: #9c9c9c;
}

.order ul li .store .btn:hover {
    color: #014492;
    border-color: #014492;
  }
.title10{
  width: 85%;
  float: left;
}
.top{
  overflow: auto;
  .you{
    font-size: 14px;
    margin-top: 10px;
    a{
      color: #666666;
    }
}
}
</style>
<template>
  <div class="user">
    <section>
      <div class="top">
        <h3 class="title title10" >我的优惠券</h3>
<!--        <div class="you">-->
<!--          <a href="http://8.130.53.158/theme/coupon">-->
<!--            <i class="iconfont icon-weibiaoti2fuzhi02"></i>-->
<!--            领取更多优惠券-->
<!--          </a>-->
<!--        </div>-->
      </div>

      <div class="search-form">
        <el-tabs v-model="status" @tab-click="getOrders">
          <el-tab-pane label="全部" name=""></el-tab-pane>
          <el-tab-pane label="未使用" name="unused"></el-tab-pane>
          <el-tab-pane label="已使用" name="used"></el-tab-pane>
<!--          <el-tab-pane label="已过期" name="expired"></el-tab-pane>-->
        </el-tabs>
      </div>
      <div class="order">
        <ul style="margin-bottom: 20px;">
          <li v-for="(item,index) in list" :key="index">
            <div style="overflow: auto"  v-if="list[index].isUsed === false">
              <div class="name">
                <span class="not-used">未使用</span>
                <h5 class="text-overflow text-xl" >{{ item.coupon.name }}</h5>
                <p v-if="item.coupon.beginDate">{{ item.coupon.beginDate | rTime1 }} 至 {{item.coupon.endDate | rTime1}}</p>
                <p v-else>无使用期限</p>
              </div>
              <div class="store">
                <a class="text-left" :href="`http://8.130.53.158/store/${item.coupon.storeId}`" target="_blank">
                  <span>限店铺:</span>
                  {{ item.coupon.storeId | stateFormat(item.coupon.storeId)}}
                </a>
                <a class="btn btn-default" :href="`http://8.130.53.158/store/${item.coupon.storeId}`">立即使用</a>
              </div>
              <div class="no-data" v-show="list.length === 0">暂无优惠券</div>
            </div>
            <div style="overflow: auto"  v-if="list[index].isUsed !== false">
            <div class="name">
              <span class="used">已使用</span>
              <h5 class="text-overflow text-xl" >{{ item.coupon.name }}</h5>
              <p >使用日期: {{ item.usedDate | rTime1 }}</p>
            </div>
            <div class="store">
              <a class="text-left" :href="`http://8.130.53.158/store/${item.coupon.storeId}`" target="_blank">
                <span>限店铺:</span>
                {{ item.coupon.storeId | stateFormat(item.coupon.storeId)}}
              </a>
              <a class="btn1 btn-default disabled">已使用</a>
            </div>
            </div>
          </li>
        </ul>

      </div>
    </section>
  </div>
</template>

<script>
import { mycoupon } from '@/services/api.index'
export default {
  data() {
    return {
      use:'',
      use1:false,
      list:[]
    }
  },
  created() {
    this.getOrders()
  },
  filters: {
    stateFormat(stateId) {
      if(stateId === 1) return '实验耗材'
      if(stateId === 2) return '生化试剂'
      if(stateId === 3) return '科研仪器'
      if(stateId === 4) return '分子生物学'
      if(stateId === 5) return '细胞生物学'
      if(stateId === 6) return '蛋白与免疫'
      return
    }
  },
  methods: {
    // 持有的优惠券列表
    getOrders(){
      mycoupon(this.status).then(res => {
        this.list = res.data
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/children/My_Coupons.vue